import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleUnauthorized } from '../../src/utils/apiHelper';
import Loader from "../../src/components/child/Loder";
const useReactApexChart = (timeframe) => {
  const [EarningChartSeries, setEarningChartSeries] = useState([]);
  const [EarningChartOptions, setEarningChartOptions] = useState({});
  const [UserChartSeries, setUserChartSeries] = useState([]);
  const [UserChartOption, setUserChartOption] = useState({});
  const [BookingChartSeries, setBookingChartSeries] = useState([]);
  const [BookingChartOptions, setBookingChartOptions] = useState({});
  const [items, setItems] = useState({});
  const [loading, setLoading] = useState(true);
  const authToken = localStorage.getItem('authToken');
  const navigate = useNavigate();
  

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/admin-dashboard`;
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINT, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const datas = await response.json();
      setItems(datas.data || {});
    } catch (error) {
      // console.error('Fetch error:', error);
      setItems({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!items || Object.keys(items).length === 0) return; // wait until data is loaded
  // console.log('ItemData...', items);
    if (timeframe === 'Weekly') {
    const earningData = items.weeklyEarningsChart || [];
    // console.log('earningData...', earningData);

    // Extract earnings and formatted dates
    const earnings = earningData.map(item => item.earnings);
    const formattedDates = earningData.map(item => {
      const dateObj = new Date(item.date);
      return dateObj.toLocaleDateString('en-GB'); // e.g., "02/05/2025"
    });

    setEarningChartSeries([{ name: 'Earnings', data: earnings }]);

    setEarningChartOptions({
      chart: {
        type: 'line',
        toolbar: { show: false }
      },
      xaxis: {
        categories: formattedDates
      }
    });
      }
 else if (timeframe === 'Monthly') {
      const earningData = items.monthlyEarningsChart || [];
      // console.log('earningData...',earningData);

      const earnings = earningData.map(item => item.earnings);
      const formattedDates = earningData.map(item => {
        const dateObj = new Date(item.date);
       return dateObj.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); // e.g., "2 May"
      });

      setEarningChartSeries([{ name: 'Earnings', data: earnings }]);
      setEarningChartOptions({
        chart: { type: 'area', toolbar: { show: false } },
        xaxis: { categories: formattedDates },
      });

      const BookingData = items.bookingCountByStorageType || [];
      const BookingCatData = BookingData.map(item => item.bookingCount);
      const BookingCat = BookingData.map(item => item.storageTypeTitle);

      setBookingChartSeries(BookingCatData);
      setBookingChartOptions({
        chart: {
          width: 380,
          type: 'pie'
        },
        labels: BookingCat,
        colors: ['#4BC0C0', '#FFCE56','#36A2EB','#FF6384','#9966FF', '#FF9F40'],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 200 },
              legend: {
                show: true,
                position: 'bottom',
                horizontalAlign: 'center',
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
      });
    

       const UserDats = items.yearlyUserChart || [];
        const UserGrow = UserDats.map(item => item.newUsers);
        const UserDate = UserDats.map(item => item.month.split(' ')[0]);

      // console.log('UserDats...',UserDats);

    setUserChartSeries([{ name: 'User Growth', data: UserGrow }]);
      setUserChartOption({
        chart: {
          type: 'area',
          toolbar: { show: false }
        },
        xaxis: {
          categories: UserDate
        },
        colors: ['#16739d'], // 🌿 Green color (you can use any HEX/RGB)
        stroke: {
          curve: 'smooth',
          width: 2
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100]
          }
        },
        markers: {
          size: 4
        }
      });


  
    } else if (timeframe === 'Yearly') {
        
        const earningData = items.yearlyEarningsChart || [];
        const earnings = earningData.map(item => item.earnings);
        const months = earningData.map(item => item.month.split(' ')[0]);

      // console.log('earningData...',earningData);
      setEarningChartSeries([{ name: 'Earnings', data: earnings }]);
      setEarningChartOptions({
        chart: { type: 'area', toolbar: { show: false } },
        xaxis: { categories: months },
      });
    }
  }, [timeframe, items]);

  return {
    EarningChartSeries,
    EarningChartOptions,
    UserChartSeries,
    UserChartOption,
    BookingChartSeries,
    BookingChartOptions,
    loading,
  };
};

export default useReactApexChart;
